<template>
  <v-container fluid fill-height justify-center
      align-center>
      <v-flex xs12 sm9>
            <v-toolbar color="primary">
               <v-toolbar-title class="white--text">New Policy - Turkey</v-toolbar-title>
            </v-toolbar>
            <div>
               <v-stepper v-model="e1">
                  <v-stepper-header>
                     <v-stepper-step step="1" :complete="e1 > 1">New Policy</v-stepper-step>
                     <v-divider></v-divider>
                     <v-stepper-step step="2" :complete="e1 > 2"> Insurance Plan</v-stepper-step>
                     <v-divider></v-divider>
                     <v-stepper-step step="3" :complete="e1 > 3">Travel Details</v-stepper-step>
                     <v-divider></v-divider>
                     <v-stepper-step step="4" :complete="e1 > 4">Quotation</v-stepper-step>
                     <v-divider></v-divider>
                     <v-stepper-step step="5" :complete="e1 > 5">Beneficiary Details</v-stepper-step>
                     <v-divider></v-divider>
                     <v-stepper-step step="6">Confirmation</v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items>
                     <v-stepper-content step="1">
                        <v-form v-model="valid" ref="newpolicy" lazy-validation >
                          <v-container fluid>
                           <v-layout row wrap align-center>
                              <v-flex>
                                 <span>Beneficiary Type:</span>
                                    <v-radio-group v-model="policy.insurance_type"  :rules="inputRules" >
                                        <v-radio label="Single" value="Single" name="beneficiary"></v-radio>
                                        <v-radio label="Family" value="Family" name="beneficaryType"></v-radio>
                                        <v-radio label="Group" value="Group" name="beneficaryType"></v-radio>
                                    </v-radio-group>
                              </v-flex>
                           </v-layout>
                           <div row v-if="policy.insurance_type === 'Family'">
                              <v-layout row wrap align-center>
                                <v-flex>
                                    <span>Parents:</span>
                                </v-flex>
                                 <v-flex xs9>
                                    <v-select
                                        :prepend-icon="policy.total_parents === 1 ? 'person' : 'people'"
                                       v-bind:items="inputParents"
                                       v-model="policy.total_parents"
                                       label="Select"
                                       single-line
                                       item-value="number"
                                       data-vv-name="parents"
                                       :rules="[v => !!v || 'Please, select a proper value.']"
                                       :mandatory="true"
                                       v-validate ="{ rules: { required: policy.insurance_type === 'Family' } }"
                                       bottom
                                       required
                                       ></v-select>
                                 </v-flex>
                              </v-layout>
                              <v-layout row wrap align-center>
                                 <v-flex>
                                    <span>Kids:</span>
                                 </v-flex>
                                 <v-flex xs9>
                                    <v-text-field
                                       prepend-icon="face"
                                       label="Number of kids"
                                       v-model.number="policy.total_children"
                                       data-vv-name="number of kids"
                                       :rules="[v => !!policy.total_parents || 'Please, enter a number of kids.']"
                                       v-validate ="{ rules: { required: policy.insurance_type === 'Family' } }"
                                       required
                                       ></v-text-field>
                                 </v-flex>
                              </v-layout>
                           </div>
                           <div row v-if="policy.insurance_type === 'Group'">
                              <v-layout row wrap align-center>
                                 <v-flex>
                                    <span>Number of people:</span>
                                 </v-flex>
                                 <v-flex xs8>
                                    <v-text-field
                                       prepend-icon="group_add"
                                       label="People"
                                       v-model.number="policy.total_persons"
                                       data-vv-name="Input people"
                                       :rules="[v => (!!v && v>1) || 'Please, enter a number of people. Must be greater than 1.']"
                                       v-validate ="{ rules: { required: policy.insurance_type === 'Group' } }"
                                       required
                                       ></v-text-field>
                                 </v-flex>
                              </v-layout>
                           </div>
                          </v-container>
                        </v-form>
                        <v-btn color="primary" @click.native="addToPersons(); validateNewPolicy(); checkToken();">Continue</v-btn>
                     </v-stepper-content>
                     <v-stepper-content step="2">
                        <v-container fluid>
                           <v-layout row wrap align-center>
                              <v-flex>
                                 <v-list two-line subheader>
                                   <v-form v-model="valid" ref="insuranceplan" lazy-validation>
                                     <span>Insurance Plan</span>
                                    <span>
                                       <v-layout row wrap align-center>
                                          <v-flex>
                                             <v-select
                                                prepend-icon="assignment"
                                                v-bind:items="insurancePlans"
                                                v-model="policy.insurance_plan_id"
                                                item-text="name"
                                                item-value="id"
                                                label="Select insurance plan"
                                                max-height
                                                multi-line
                                                disabled
                                                :rules="[v => !!v || 'Please, select a plan.']"
                                                bottom
                                                required
                                                ></v-select>
                                          </v-flex>
                                       </v-layout>
                                    </span>
                                    <span v-for="(person, key) in policy.persons" :key="person" class="mt-3">
                                       <span v-if="key === 0" > Beneficiary</span>
                                       <span v-if="policy.total_parents > 1 && key == 1"> Spouse</span>
                                       <span v-if="policy.total_children && (policy.total_parents === 1 && key !== 0)"> Child {{ key }}</span>
                                       <span v-if="policy.total_children && (policy.total_parents === 2 && key !== 0 && key !== 1)"> Child {{ key - 1 }}</span>
                                       <span v-if="!policy.total_children && !policy.total_parents && key != 0"> User {{ key }}</span>
                                       <v-layout row wrap align-center>
                                          <v-flex>
                                             <v-menu
                                                lazy
                                                :close-on-content-click="false"
                                                v-model="policy.persons[key].menu"
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                :nudge-right="40"
                                                max-width="290px"
                                                min-width="290px"
                                                >
                                                <v-text-field
                                                    prepend-icon="date_range"
                                                   slot="activator"
                                                   label="Date of birth"
                                                   v-model="person['date_of_birth']"
                                                   :rules="[v => !!v || 'Please, select a date of birth.']"
                                                   readonly
                                                   required
                                                   ></v-text-field>
                                                <v-date-picker
                                                  v-model="person['date_of_birth']"
                                                   no-title 
                                                  scrollable 
                                                  actions
                                                  disabled
                                                  :allowed-dates="years"
                                                >
                                                   <template slot-scope="{ save, cancel }">
                                                      <v-card-actions>
                                                         <v-spacer></v-spacer>
                                                         <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                                         <v-btn flat color="primary" @click="save">OK</v-btn>
                                                      </v-card-actions>
                                                   </template>
                                                </v-date-picker>
                                             </v-menu>
                                          </v-flex>
                                       </v-layout>
                                    </span>
                                   </v-form>
                                 </v-list>
                              </v-flex>
                           </v-layout>
                        </v-container>
                        <br>
                        <br>
                        <v-btn color="primary" :disabled="!valid" @click.native="validateInsurancePlan(); checkToken();">Continue</v-btn>
                        <v-btn outline @click.native="goBack(); checkToken();">Back</v-btn>
                     </v-stepper-content>
                     <v-stepper-content step="3">
                        <v-container fluid>
                           <v-layout row wrap align-center>
                             <v-flex>
                              <v-list two-line subheader>
                                <v-form v-model="valid" ref="traveldetails" lazy-validation >
                                  <v-layout row wrap align-center>
                                      <v-flex xs12>
                                          <span>Residence:</span>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-select
                                            prepend-icon="flag"
                                            v-bind:items="states"
                                            v-model="policy.country_residence"
                                            label="Country"
                                            :rules="[v => !!v || 'Please, select a country of residence.']"
                                            autocomplete
                                            bottom
                                            required
                                            ></v-select>
                                      </v-flex>
                                  </v-layout>
                                  <v-layout row wrap align-center>
                                      <v-flex xs12>
                                        <span>Destination:</span>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-select
                                            prepend-icon="map"
                                            v-bind:items="policy.country_destination"
                                            v-model="policy.country_destination"
                                            label="Country"
                                            class="input-group"
                                            :rules="[v => !!v || 'Please, select a country of destination.']"
                                            disabled
                                            autocomplete
                                            required
                                            ></v-select>
                                      </v-flex>
                                  </v-layout>
                                  <v-layout row wrap align-center>
                                      <v-flex>
                                        <span>Duration:</span>
                                      </v-flex>
                                      <v-flex xs12 lg5>
                                        <v-menu
                                            lazy
                                            :close-on-content-click="false"
                                            v-model="policy.duration_fromMenu"
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            :nudge-right="40"
                                            max-width="290px"
                                            min-width="290px"
                                            >
                                            <v-text-field
                                              slot="activator"
                                              label="From"
                                              v-model="policy.duration_from"
                                              prepend-icon="event"
                                              :rules="[v => !!v || 'Please, select a date.']"
                                              readonly
                                              ></v-text-field>
                                            <v-date-picker 
                                              v-model="policy.duration_from"
                                              no-title 
                                                scrollable 
                                                actions
                                                disabled
                                                :allowed-dates="durationFrom">
                                              <template slot-scope="{ save, cancel }">
                                                  <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                                    <v-btn flat color="primary" @click="save">OK</v-btn>
                                                  </v-card-actions>
                                              </template>
                                            </v-date-picker>
                                        </v-menu>
                                      </v-flex>
                                      <v-flex xs12 lg5>
                                        <v-menu
                                            lazy
                                            :close-on-content-click="false"
                                            v-model="policy.duration_toMenu"
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            :nudge-right="40"
                                            max-width="290px"
                                            min-width="290px"
                                            >
                                            <v-text-field
                                              slot="activator"
                                              label="To"
                                              v-model="policy.duration_to"
                                              prepend-icon="event"
                                              :rules="[v => !!v || 'Please, select a date.']"
                                              readonly
                                              ></v-text-field>
                                            <v-date-picker 
                                            v-model="policy.duration_to"
                                            no-title 
                                            scrollable 
                                            actions
                                            disabled
                                            :allowed-dates="durationFrom">
                                              <template slot-scope="{ save, cancel }">
                                                  <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                                    <v-btn flat color="primary" @click="save">OK</v-btn>
                                                  </v-card-actions>
                                              </template>
                                            </v-date-picker>
                                        </v-menu>
                                      </v-flex>
                                  </v-layout>
                                </v-form>
                              </v-list>
                             </v-flex>
                           </v-layout>
                        </v-container>
                        <br>
                        <br>
                        <v-btn color="primary" :disabled="!valid" @click.native="quoteCalculator(); validateTraveDetails(); checkToken();">Continue</v-btn>
                        <v-btn outline @click.native="goBack(); checkToken();">Back</v-btn>
                     </v-stepper-content>
                     <v-stepper-content step="4">
                        <v-container fluid>
                           <v-layout row wrap align-center>
                              <v-flex xs12 >
                                <v-card>
                                <v-toolbar color="primary" dark>
                                  <v-toolbar-title>Quotation</v-toolbar-title>
                                </v-toolbar>
                                <v-list three-line subheader>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Plan</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ getPlanName }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Insurance Type</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ policy.insurance_type }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Country of residence</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ policy.country_residence }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Country of destination</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ policy.country_destination }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Date from</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ policy.duration_from }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Date to</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ policy.duration_to }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Duration</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ duration }} days</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Price</v-list-tile-title>
                                      <v-list-tile-sub-title>$ {{ policy.amount }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-list>
                                <v-divider></v-divider>
                              </v-card>
                              </v-flex>
                           </v-layout>
                        </v-container>
                        <br>
                        <br>
                        <v-btn color="primary" :disabled="!valid" @click.native="e1++; checkToken();">Continue</v-btn>
                        <v-btn outline @click.native="goBack(); checkToken();">Back</v-btn>
                     </v-stepper-content>
                     <v-stepper-content step="5">
                        <v-container fluid>
                           <v-layout row wrap align-center>
                              <v-flex xs12 >
                                 <v-list two-line subheader>
                                    <v-form v-model="valid" ref="form" lazy-validation >
                                       <span v-for="(person, key) in policy.persons" v-bind:key="key">
                                          <v-layout mt-3>
                                             <v-flex>
                                                <span class="headline" v-if="key === 0" > Beneficiary</span>
                                                <span class="headline" v-if="policy.total_parents > 1 && key == 1"> Spouse</span>
                                                <span class="headline" v-if="policy.total_children && (policy.total_parents === 1 && key !== 0)"> Child {{ key }}</span>
                                                <span class="headline" v-if="policy.total_children && (policy.total_parents === 2 && key !== 0 && key !== 1)"> Child {{ key - 1 }}</span>
                                                <span class="headline" v-if="!policy.total_children && !policy.total_parents && key != 0"> User {{ key }}</span>
                                             </v-flex>
                                          </v-layout>
                                          <v-flex>
                                             <v-text-field
                                                label="First Name"
                                                v-model="person.first_name"
                                                :rules="inputRules"
                                                required
                                                ></v-text-field>
                                          </v-flex>
                                          <v-flex>
                                             <v-text-field
                                                label="Middle Name"
                                                v-model="person.middle_name"
                                                :rules="inputRules"
                                                required
                                                ></v-text-field>
                                          </v-flex>
                                          <v-flex>
                                             <v-text-field
                                                label="Last Name"
                                                v-model="person.last_name"
                                                :rules="inputRules"
                                                required
                                                ></v-text-field>
                                          </v-flex>
                                          <v-flex>
                                             <v-text-field
                                                prepend-icon="picture_in_picture"
                                                label="Passport Number"
                                                v-model="person.passport_number"
                                                :rules="inputRules"
                                                required
                                                ></v-text-field>
                                          </v-flex>
                                          <v-layout row mt-2>
                                             <v-flex xs12>
                                                <v-flex>
                                                   <span prepend-icon="email" >Gender:</span>
                                                </v-flex>
                                                <v-flex >
                                                   <span>
                                                      <v-radio-group v-model="person.gender"  :rules="[v => !!v || 'Please, select a gender.']" :mandatory="true" row>
                                                         <v-radio label="Male" value="M"></v-radio>
                                                         <v-radio label="Female" value="F"></v-radio>
                                                      </v-radio-group>
                                                   </span>
                                                </v-flex>
                                             </v-flex>
                                          </v-layout>
                                          <v-layout row wrap mt-2>
                                             <v-flex>
                                                <v-flex>
                                                   <span>Do you have any pre-existing medical condition?</span>
                                                </v-flex>
                                                <v-flex mt-2>
                                                <v-switch v-bind:label="person.has_existing_medical_condition ? 'Yes' : 'No'" value  v-model="person.has_existing_medical_condition"></v-switch>
                                                </v-flex>
                                                <v-flex v-if="person.has_existing_medical_condition">
                                                   <span>
                                                      <v-text-field
                                                         name="input-7-1"
                                                         label="Please explain your condition"
                                                         textarea
                                                         v-model="person.existing_medical_condition"
                                                         :rules="[v => !!v || 'This field is required.']"
                                                         ></v-text-field>
                                                   </span>
                                                </v-flex>
                                             </v-flex>
                                          </v-layout>
                                          <v-layout row wrap mt-2>
                                             <v-flex>
                                                <v-flex>
                                                   <span>Medical coverage with an insurance company in {{policy.country_residence}}?</span>
                                                </v-flex>
                                                <v-flex mt-2>
                                                     <v-switch v-bind:label="person.has_medical_insurance_in_country_of_residence ? 'Yes' : 'No'" value  v-model="person.has_medical_insurance_in_country_of_residence"></v-switch>
                                                </v-flex>
                                                <v-flex v-if="person.has_medical_insurance_in_country_of_residence">
                                                   <span>
                                                      <v-text-field
                                                         name="input-7-1"
                                                         label="Please state name and expire date"
                                                         textarea
                                                         :rules="[v => !!v || 'This field is required.']"
                                                         v-model="person.medical_insurance_in_country_of_residence"
                                                         ></v-text-field>
                                                   </span>
                                                </v-flex>
                                             </v-flex>
                                          </v-layout>
                                           <v-divider></v-divider>
                                       </span>
                                       <v-layout row mt-2>
                                          <v-flex>
                                             <span class="headline">Contact info</span>
                                          </v-flex>
                                       </v-layout>
                                       <v-flex>
                                          <v-text-field
                                             prepend-icon="email"
                                             label="Contact email"
                                             v-model="policy.email"
                                             :rules="emailRules"
                                             required
                                             ></v-text-field>
                                       </v-flex>
                                       <v-flex>
                                          <v-text-field
                                             prepend-icon="phone"
                                             label="Contact phone"
                                             v-model="policy.phone"
                                             :rules="phoneValidation"
                                             required
                                             ></v-text-field>
                                       </v-flex>
                                    </v-form>
                                 </v-list>
                              </v-flex>
                           </v-layout>
                        </v-container>
                        <br>
                        <br>
                        <v-btn color="primary" :disabled="!valid" @click.native="validateLastForm(); checkToken();">Continue</v-btn>
                        <v-btn outline @click.native="goBack(); checkToken();">Back</v-btn>
                     </v-stepper-content>
                     <v-stepper-content step="6">
                        <v-container fluid>
                            <v-layout row wrap align-center>
                              <v-flex xs12>

                              <v-card>
                                <v-toolbar color="primary" dark>
                                  <v-toolbar-title>Quotation</v-toolbar-title>
                                </v-toolbar>
                                <v-list three-line subheader>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Plan</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ getPlanName }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Insurance Type</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ policy.insurance_type }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Country of residence</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ policy.country_residence }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Country of destination</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ policy.country_destination }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Date from</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ policy.duration_from }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Date to</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ policy.duration_to }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Duration</v-list-tile-title>
                                      <v-list-tile-sub-title>{{ duration }} days</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Price</v-list-tile-title>
                                      <v-list-tile-sub-title>$ {{ policy.amount }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-list>
                                <v-divider></v-divider>
                              </v-card>
                            <v-card v-for="(person, key) in policy.persons" v-bind:key="key">
                              <v-divider></v-divider>
                              <v-toolbar color="primary" dark>
                                  <v-toolbar-title class="headline" v-if="key === 0" > Beneficiary</v-toolbar-title>
                                  <v-toolbar-title class="headline" v-if="policy.total_parents > 1 && key == 1"> Spouse</v-toolbar-title>
                                  <v-toolbar-title class="headline" v-if="policy.total_children && (policy.total_parents === 1 && key !== 0)"> Child {{ key }}</v-toolbar-title>
                                  <v-toolbar-title class="headline" v-if="policy.total_children && (policy.total_parents === 2 && key !== 0 && key !== 1)"> Child {{ key - 1 }}</v-toolbar-title>
                                  <v-toolbar-title class="headline" v-if="!policy.total_children && !policy.total_parents && key != 0"> User {{ key }}</v-toolbar-title>
                                </v-toolbar>
                                <v-list three-line subheader>
                                    <v-list-tile avatar>
                                      <v-list-tile-content>
                                        <v-list-tile-title>First Name</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ person.first_name }}</v-list-tile-sub-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-list-tile avatar>
                                      <v-list-tile-content>
                                        <v-list-tile-title>Middle Name</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ person.middle_name }}</v-list-tile-sub-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-list-tile avatar>
                                      <v-list-tile-content>
                                        <v-list-tile-title>Last Name</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ person.last_name }}</v-list-tile-sub-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-list-tile avatar>
                                      <v-list-tile-content>
                                        <v-list-tile-title>Passport Number</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ person.passport_number }}</v-list-tile-sub-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-list-tile avatar>
                                      <v-list-tile-content>
                                        <v-list-tile-title>Date of birth</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ person.date_of_birth }}</v-list-tile-sub-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-list-tile>
                                      <v-list-tile-content>
                                        <v-list-tile-title>Gender</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ person.gender }}</v-list-tile-sub-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider v-if="person.has_existing_medical_condition"></v-divider>
                                    <v-list-tile v-if="person.has_existing_medical_condition">
                                      <v-list-tile-content>
                                        <v-list-tile-sub-title>Pre Existing Medical Condition</v-list-tile-sub-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                    <v-flex xs10 offset-xs1 v-if="person.has_existing_medical_condition">
                                        <span>
                                          <v-text-field
                                              name="input-7-1"
                                              label="Explanation"
                                              textarea
                                              readonly
                                              v-model="person.existing_medical_condition"
                                              ></v-text-field>
                                        </span>
                                    </v-flex>
                                    <v-divider v-if="person.has_medical_insurance_in_country_of_residence"></v-divider>
                                    <v-list-tile v-if="person.has_medical_insurance_in_country_of_residence">
                                      <v-list-tile-content>
                                        <v-list-tile-sub-title>Medical coverage with an insurance company in {{policy.country_residence}}</v-list-tile-sub-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                    <v-flex xs10 offset-xs1 v-if="person.has_medical_insurance_in_country_of_residence">
                                        <span>
                                          <v-text-field
                                              name="input-7-1"
                                              label="Explanation"
                                              textarea
                                              readonly
                                              v-model="person.medical_insurance_in_country_of_residence"
                                              ></v-text-field>
                                        </span>
                                    </v-flex>
                                  </v-list>
                            </v-card>
                          </v-flex>

                          </v-layout>
                        </v-container>
                        <v-btn color="warning"
                        :disabled="disabledFinal" @click.native="savePolicy">Save</v-btn>
                        <v-btn outline @click.native="goBack">Back</v-btn>
                     </v-stepper-content>
                  </v-stepper-items>
               </v-stepper>
            </div>
         </v-flex>
      <div row>
        <v-alert
          :color="alert.type"
          icon="check_circle"
          :value="alert.status"
          transition="scale-transition"
        >
          {{ alert.message }}
        </v-alert>
      </div>
   </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import {countryCodesSingle, countriesTo} from "../../../../helpers/countryCodes.js";
export default {
  data: () => ({
    alert: {
      status: false,
      message: '',
      type: ''
    },
    years: {
      min: null,
      max: null
    },
    durationFrom: {
      min: null,
      max: null
    },
    maxAge: null,
    disabledFinal: false,
    valid: true,
    phoneValidation: [v => !!v || "Phone number is required", v => /^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."],
    inputRules: [v => !!v || "Input field is required"],
    emailRules: [  
        v => !!v || "E-mail is required",
        v =>
        /\S+@\S+\.\S+/.test(v) ||
        "E-mail must be valid"
    ],
    e1:1,
    allPersonsValid: true,
    name: '',
    beneficaryType: false,
    date: null,
    menu: false,
    modal: false,
    duration: "",
    inputParents: [
      { text: "Single Parent", number: 1 },
      { text: "Both Parents", number: 2 }
    ],
    personObj: {
      date_of_birth: null,
      menu: null,
      first_name: "",
      middle_name: "",
      last_name: "",
      passport_number: "",
      gender: "",
      has_existing_medical_condition: false,
      existing_medical_condition: "",
      has_medical_insurance_in_country_of_residence: false,
      medical_insurance_in_country_of_residence: ""
    },
    policy: {  
      insurance_plan_id: "",
      insurance_type: "",
      total_parents: null,
      total_children: null,
      total_persons: null,
      country_residence: "",
      country_destination: "Turkey",
      duration_from: null,
      duration_fromMenu: false,
      duration_to: null,
      duration_toMenu: false,
      email: "",
      phone: "",
      amount: "",
      persons: []
    },
    insurancePlans: [],
    selectedInsurancePlan: {},
    states: countryCodesSingle,
    statesTo: countriesTo
  }),
  computed: {
    getPlanName: function () {
      let planName = ""
      this.insurancePlans.forEach(plan => {
        if (plan.id === this.policy.insurance_plan_id) {
          planName = plan.short_name
        }
      });
      return planName;
    }
  },
  methods: {
    checkToken() {
      this.$auth.loggedIn() ? true : this.$router.push('/auth/login');
    },
    goBack() {
      this.e1--;
    },
    alerting(){
      this.alert.status = !this.alert.status;
    },
    redirect(uuid) {
      this.$router.push({ path: `/agency/issued_policies/show/` + uuid });
    },
    savePolicy(){
      let vm = this
      this.disabledFinal = true;
      axios.post('/policies', {policy: this.policy})
          .then(res => {
            this.alert.message = 'Policy has been created.'
            this.alert.type = 'success'
            this.alerting()
            this.$root.$emit('updateBalance')
            setTimeout(() => {
                this.alert.status = !this.alert.status;
                if (this.allPersonsValid) {
                  this.redirect(res.data.uuid)
                }
            }, 5000);
          })
          .catch(err => {
            this.disabledFinal = false;
            this.alert.message = err.response.data.message || 'Failed to create a policy'
            this.alert.type = 'error'
            this.alerting()
            setTimeout(() => {
                this.alert.status = !this.alert.status;
            }, 5000);
          })
    },
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result == true) {
          this.$validator.reset()
          this.e1++;
          return;
        }
      });
    },
    validateLastForm() {
      if (this.$refs.form.validate()) {
        this.e1++;
      }
    },
    validateNewPolicy() {
      if (this.$refs.newpolicy.validate()) {
        this.e1++;
      }
    },
    validateMaxAge() {
      let planObj;
      let maxAgeLength;
      let planObjDuration;
      this.insurancePlans.forEach(plan => {
        let vm = this;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });
      this.maxAge = planObj.pricing[planObj.pricing.length - 1].end;
      this.years.min = moment().subtract(maxAge, "years").format('YYYY-MM-DD');
    },
    validateDurationTo() {
      let planObj;
      this.insurancePlans.forEach(plan => {
        let vm = this;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });
      let planObjArrLength = planObj.pricing[0].pricing.length;
      let planObjDuration = planObj.pricing[0].pricing[planObjArrLength - 1].duration
      this.durationFrom.max = moment(this.policy.duration_from).add(planObjDuration, "days").format('YYYY-MM-DD');;
    },
    validateInsurancePlan() {
      if (this.$refs.insuranceplan.validate()) {
        this.e1++;
      }
    },
    validateTraveDetails () {
      let planObj;
      this.insurancePlans.forEach(plan => {
        let vm = this;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });
      let planObjArrLength = planObj.pricing[0].pricing.length;
      let planObjDuration = planObj.pricing[0].pricing[planObjArrLength - 1].duration
      
      if (this.$refs.traveldetails.validate() && this.allPersonsValid === true) {
        if (moment(this.policy.duration_to).isBefore(this.policy.duration_from) || moment(this.policy.duration_from).isAfter(this.policy.duration_to)) {
          this.alert.message = 'Duration From and To are not valid, please check your dates.'
          this.alert.type = 'error'
          this.alerting()
          setTimeout(() => {
                this.alert.status = !this.alert.status;
            }, 5000);
        } else if (this.duration > planObjDuration) {
          this.alert.message = `Duration should not be longer than ${planObjDuration} days, please change your dates.`
          this.alert.type = 'error'
          this.alerting()
          setTimeout(() => {
                this.alert.status = !this.alert.status;
            }, 5000);
        } else if (moment(this.policy.duration_from).isBefore()) {
          this.alert.message = 'Policy starting date should not be before tomorrow.'
          this.alert.type = 'error'
          this.alerting()
          setTimeout(() => {
                this.alert.status = !this.alert.status;
            }, 5000);
        } else {
          this.e1++;
        }
      }
    },
    addToPersons() {
      this.policy.persons = [];
      const vm = this;
      if (this.policy.insurance_type === "Single") {
        this.policy.persons.push(JSON.parse(JSON.stringify(this.personObj)));
      } else if (this.policy.insurance_type === "Family") {
        this.policy.total_persons = null
        for (let index = 0; index < this.policy.total_parents; index++) {
          this.policy.persons.push(JSON.parse(JSON.stringify(this.personObj)));
        }
        for (let index = 0; index < this.policy.total_children; index++) {
          this.policy.persons.push(JSON.parse(JSON.stringify(this.personObj)));
        }
      } else {
        this.policy.total_parents = null;
        this.policy.total_children = null;
        for (let index = 0; index < this.policy.total_persons; index++) {
          this.policy.persons.push(JSON.parse(JSON.stringify(this.personObj)));
        }
      }
    },
    calcPolicyDuration(start, finish) {
      const pocetak = moment(start);
      const kraj = moment(finish);
      const result = kraj.diff(pocetak, "days");
      return result;
    },
    getPersonYear(dob) {
      return moment().diff(dob, "years");
    },
    quoteCalculator() {
      let duration = this.calcPolicyDuration(this.policy.duration_from, this.policy.duration_to);
      this.duration = duration;

      let ages = [];
      this.policy.persons.forEach(person => {
        ages = [... ages, this.getPersonYear(person.date_of_birth)]
      });

      let planObj;
      this.insurancePlans.forEach(plan => {
        let vm = this;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });

      let prices = [];
      ages.map(personAge => {
        planObj.pricing.map(helperObj => {
          if (helperObj.begin <= personAge && personAge <= helperObj.end) {
              helperObj.pricing.some((range, index) => {
                if (duration <= range.duration) {
                  return prices = [... prices, parseInt(range.price)]
                }
              });
          }
        });
      });

      this.policy.amount = prices.length > 1 ? prices.reduce((acc, cur) => acc + cur, 0) : prices[0];
    },
    getPlanObject (id) {
      this.insurancePlans.forEach(plan => {
        if (plan.id === id) {
          this.selectedInsurancePlan = plan;
        }
      });
    }
  },
  mounted() {
    axios.get("/insuranceplans").then(response => {
      response.data.insurancePlans.map(plan => {
        if (plan.name == "Turkey") {
          this.policy.insurance_plan_id = plan.id
          this.insurancePlans.push(plan)
        }
      })
    });
    this.years.min = moment().subtract(80, "years").format('YYYY-MM-DD');
    this.years.max = moment().subtract(1, "years").format('YYYY-MM-DD');
    this.durationFrom.min = moment().add(1,'day').format('YYYY-MM-DD');
    this.durationFrom.max = moment().add(730, 'days').format('YYYY-MM-DD');
  },
  watch: {    
    'policy.insurance_plan_id': function (val) {
      this.validateMaxAge();
      this.validateDurationTo();
    },
    'policy.duration_from': function (val) {
      this.validateDurationTo();
    }
  }
};
</script>

<style scoped>
.input-group--selection-controls {
  color: #28AFAF !important;
}
.text-error {
  color: #ff5252 !important;
}
.input-group__error {
  color: #ff5252 !important;
}
.divider {
  margin-top: 12px !important;
}
.table {
  background: #e7e7e8;
  width: auto;
  table-layout: fixed
}

.table th {
  font-weight: 400;
  padding-right: 30px !important;
  background: none
}

.table td {
  font-weight: 700;
  min-width: 200px;
}

.table>thead>tr>th,
.table>tbody>tr>th,
.table>tfoot>tr>th,
.table>thead>tr>td,
.table>tbody>tr>td,
.table>tfoot>tr>td {
  border-top: none;
  padding: 5px 10px
}

.table,
.table tr+tr {
  border: none
}

.table .empty-cell {
  height: 30px
}

.table tr:nth-child(even) {
  background: #d1d2d4
}


table th {
  white-space: nowrap;
  background: #e7e7e8
}

table th,
table td {
  padding: 12px 15px;
  text-align: left
}

table tr+tr {
  border-top: 1px solid #eee
}
input {
  width: 50px !important;
  border-bottom: 1px solid grey !important;
}
</style>




// WEBPACK FOOTER //
// src/components/agency/Policy/NewPolicy/NewPolicyTurkey.vue